import PropTypes from 'prop-types'

import classes from './Drawer.module.scss'

const DrawerEmptyState = ({ children }) => <span className={classes.empty}>{children}</span>

DrawerEmptyState.propTypes = {
  children: PropTypes.node.isRequired,
}

export default DrawerEmptyState
